var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5204",
    "data-name": "Group 5204",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 135.214,
    height: 150,
    viewBox: "0 0 135.214 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1188",
    "data-name": "Rectangle 1188",
    width: 135.214,
    height: 150,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5203",
    "data-name": "Group 5203",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5202",
    "data-name": "Group 5202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5201",
    "data-name": "Group 5201",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5200",
    "data-name": "Group 5200",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5199",
    "data-name": "Group 5199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5198",
    "data-name": "Group 5198",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4187",
    "data-name": "Path 4187",
    d: "M105.869,40.292c13.809,17.013,28.17,30.38,29.275,44.962,1.1,14.472-11.047,30.159-24.967,42.532-13.809,12.483-29.5,21.763-45.4,22.2-16.018.332-32.257-8.285-44.188-20.768A74.8,74.8,0,0,1,.148,82.934C-.957,65.48,4.124,46.81,15.945,29.908,27.765,12.9,46.435-2.35,62.454.3c16.128,2.541,29.5,23.089,43.415,39.991",
    fill: "#0af"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_4188",
    "data-name": "Path 4188",
    d: "M107.573,69.719a.958.958,0,0,0-.07-.36.946.946,0,0,0-.13-.27c-.03-.05-.03-.11-.06-.14-.05-.07-.1-.1-.14-.15s-.07-.09-.12-.14L97.6,60.468V45.908a1.6,1.6,0,0,0-1.6-1.6H78.952L68.662,35.4a1.586,1.586,0,0,0-2.1,0l-10.28,8.91H39.221a1.6,1.6,0,0,0-1.6,1.6v14.56l-9.45,8.191c-.05.03-.06.09-.11.14a.711.711,0,0,0-.15.15c-.03.04-.03.09-.06.14a1.343,1.343,0,0,0-.13.27,1.429,1.429,0,0,0-.08.37c0,.05-.03.1-.03.16V113.4a1.569,1.569,0,0,0,.03.16,1.654,1.654,0,0,0,.07.32,2.227,2.227,0,0,0,.12.31c.04.05.04.11.07.16a.21.21,0,0,0,.08.06,2.054,2.054,0,0,0,.38.34c.05.03.1.08.16.11a2.238,2.238,0,0,0,.71.14h76.782a1.58,1.58,0,0,0,.68-.16,1.158,1.158,0,0,0,.16-.11,1.481,1.481,0,0,0,.38-.33c.02-.04.06-.04.08-.07a.382.382,0,0,0,.06-.16,1.359,1.359,0,0,0,.13-.3c.03-.11.05-.21.07-.32,0-.07.03-.11.03-.16V69.879c0-.05-.03-.1-.03-.16m-9.95-5,5.82,5.04-5.82,4.18Zm-30-25.991,6.45,5.58h-12.9Zm-26.8,8.78H94.4V76.229L67.622,95.41l-26.8-19.181Zm-3.2,17.211v9.22l-5.82-4.18Zm-6.79,8.27,26.02,18.66L30.831,110.28ZM34.2,111.8,59.612,93.619l7.08,5.071a1.659,1.659,0,0,0,.93.3,1.586,1.586,0,0,0,.93-.3l7.09-5.071,25.4,18.181Zm70.222-1.5L78.392,91.649l26.031-18.66Z",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4189",
    "data-name": "Path 4189",
    d: "M74.072,44.308h-12.9l6.45-5.58Z",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4190",
    "data-name": "Path 4190",
    d: "M37.621,64.718v9.22l-5.82-4.18Z",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4191",
    "data-name": "Path 4191",
    d: "M103.443,69.759l-5.82,4.18v-9.22Z",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4192",
    "data-name": "Path 4192",
    d: "M40.821,47.508V76.229l26.8,19.18L94.4,76.229V47.508ZM78.353,78.559H56.892a1.6,1.6,0,1,1,0-3.2H78.353a1.6,1.6,0,1,1,0,3.2m8.36-10.221H48.552a1.6,1.6,0,1,1,0-3.2H86.713a1.6,1.6,0,1,1,0,3.2m0-10.21H48.552a1.6,1.6,0,1,1,0-3.2l38.161.01a1.6,1.6,0,1,1,0,3.19",
    fill: "#02e2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4193",
    "data-name": "Path 4193",
    d: "M88.313,56.528a1.6,1.6,0,0,1-1.6,1.6H48.552a1.6,1.6,0,1,1,0-3.2l38.161.01a1.6,1.6,0,0,1,1.6,1.59",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4194",
    "data-name": "Path 4194",
    d: "M88.313,66.739a1.605,1.605,0,0,1-1.6,1.6H48.552a1.6,1.6,0,1,1,0-3.2H86.713a1.6,1.6,0,0,1,1.6,1.6",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4195",
    "data-name": "Path 4195",
    d: "M79.952,76.959a1.6,1.6,0,0,1-1.6,1.6H56.891a1.6,1.6,0,0,1,0-3.2H78.353a1.6,1.6,0,0,1,1.6,1.6",
    fill: "#2b528e"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.4b14ce8cba1ebd267e49f8625eec5417.svg";
export { ForwardRef as ReactComponent };